import React from "react";
import { Link } from "react-router-dom";
// The access type labels live with the other carrier helpers, so the
// Extended PoP views can use them without importing this module (which
// imports theirs).
import {
  ACCESS_TYPE_OPTIONS,
  accessTypeLabel,
} from "kontrolEdge/helpers/carrierAccess";
import { endpointDetailPath } from "./CarrierAccessDetails/carrierAccessLegs";
// Same lifecycle values as Extended PoP (draft | provisioning | active |
// suspended | decommissioned), so the pill and its sort order are shared
// rather than copied.
import { extenderPopStatusPresentation as statusPresentation } from "../ExtenderPop/ExtenderPopData";
import type { CarrierAccessEndpoint } from "./carrierAccess.types";

/**
 * Carrier Access ("Backhaul" in the UI) — presentation shared by its detail
 * and the Admin Center. It has no list of its own any more.
 */

export { ACCESS_TYPE_OPTIONS, accessTypeLabel };

export { statusPresentation as carrierAccessStatusPresentation };

const PARENT_CONNECTION_PREFIX: Record<CarrierAccessEndpoint["type"], string> =
  {
    port: "[PORT]",
    extender_pop: "[CPE]",
  };

/**
 * The service an access hangs off, as a "Parent Connection" — the label and
 * the `[PORT]10-7E2C9A` form Cloud Connectivity and DC Interconnect already
 * use for theirs, so Carrier Access reads the same (Jose, PR #696).
 */
export const formatParentConnection = (
  endpoint: CarrierAccessEndpoint
): string =>
  `${PARENT_CONNECTION_PREFIX[endpoint.type]}${endpoint.serviceId ?? endpoint.name ?? endpoint.id}`;

/** One parent connection, linking to that Port's or Extended PoP's detail. */
export const ParentConnectionLink: React.FC<{
  endpoint: CarrierAccessEndpoint;
}> = ({ endpoint }) => (
  <Link
    to={endpointDetailPath(endpoint)}
    onClick={(event) => event.stopPropagation()}
    className="whitespace-nowrap text-sm font-medium underline text-semantic-text-brand hover:underline"
  >
    {formatParentConnection(endpoint)}
  </Link>
);
